<script setup>
import {computed} from 'vue'
import {useSiteTreeStore} from '@/stores/siteTree'

const props = defineProps({
    siteTreeId: String
})

const siteTreeStore = useSiteTreeStore(props.siteTreeId)

const navigationGroups = computed(() => {
    return siteTreeStore.navigationGroups
})

const selectedNavigationGroup = computed({
    get() {
        return siteTreeStore.selectedNavigationGroup
    },
    set(val) {
        siteTreeStore.setSelectedNavigationGroup(val)
    }
})
</script>

<template>
    <select v-model="selectedNavigationGroup" class="form-select form-select-sm w-auto">
        <option v-for="option in navigationGroups" :key="option" :value="option">
            {{ option }}
        </option>
    </select>
</template>